import { UnidadeModel } from './../../../model/endereco/unidade.model';
import { UnidadeService } from './../../../service/endereco/unidade.service';
import { DialogConfirmComponent } from './../../dialog/dialog-confirm/dialog-confirm.component';
import { MatDialog } from '@angular/material/dialog';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-unidade',
  templateUrl: './unidade.component.html',
  styleUrls: ['./unidade.component.scss']
})
export class UnidadeComponent implements OnInit {

  user: any;
  creatorUnidade = false;
  editorUnidade = false;
  listaUnidade = false;
  deletaUnidade = false;
  superUser = false;
  arrayString: string;

  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  public unidade = {} as UnidadeModel;
  public unidades: UnidadeModel[];
  public submit = false;
  @ViewChild('cardEdit') targetEl: ElementRef;
  @ViewChild('unidadeInput') unidadeInput: ElementRef;
  public formUnidade: FormGroup;
  public page: ResponsePageable;
  public pageAtual = 0;
  public loading = true;

  constructor(
    private unidadeService: UnidadeService,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    private fb: FormBuilder) { }

  ngOnInit() {
    this.getAuthority();
    this.listPageUnidade(0, 10);

    // Formulário de tipo Componente
    this.formUnidade = this.fb.group({
      id: [null],
      nome: [null, [Validators.maxLength(100), Validators.required]],
      ativo: [null],
    });
  }

  listPageUnidade(page, size) {
    this.unidadeService.getPageUnidade(page, size).subscribe(res => {
      this.loading = false;
      this.page = res;
      this.unidades = this.page.content;
    }, err => {
      console.error(err);
      this.openSnackBarError('Erro na listagem !');
      this.loading = false;
    });
  }

  listarUnidade() {
    this.unidadeService.getUnidades().subscribe(data => {
      this.unidades = data;
      this.loading = false;
    }, err => {
      console.error(err);
    });
  }

  addOrEdit() {
    console.log(this.unidade.id);
    if (this.unidade.id != null) {
      this.editarUnidade();
    } else {
      this.adicionarUnidade();
    }
  }

  limpar() {
    this.submit = false;
    this.unidade.id = null;
    this.unidadeInput.nativeElement.value = "";
    this.unidade.ativo = false;
    this.unidade.nome = null;
  }

  adicionarUnidade() {
    this.loading = true;
    if (this.formUnidade.valid) {
      let ativo = this.formUnidade.get('ativo').value;
      if (ativo !== true) {
        this.formUnidade.get('ativo').setValue(false);
      }
      this.unidadeService.adicionarUnidade(this.formUnidade.value).subscribe(data => {
        console.log(data);
          this.openSnackBarSuccess(`Unidade ${data.nome} salvo com sucesso !`);
          this.listPageUnidade(0, 10);
          this.submit = false;
          this.formUnidade.reset();
      }, err => {
        console.error(err);
        this.openSnackBarError('Erro ! ' + err.error.message);
        this.loading = false;
      });
    } else {
      this.loading = false;
      this.openSnackBarError('Preencha todos os campos obrigatórios !');
    }
  }

  editarUnidade() {
    this.loading = true;
    this.unidadeService.editarUnidade(this.unidade).subscribe(data => {
      console.log(data);
      this.openSnackBarSuccess(`Unidade ${data.nome} editado com sucesso !`);
      this.listPageUnidade(this.pageAtual, 10);
      this.submit = false;
      this.formUnidade.reset();
      this.unidade.id = null;
    }, err => {
      this.loading = false;
      console.error(err);
      this.openSnackBarError('Erro ao tentar editar a Unidade !');
    });
  }

  editarModulo(unidade: UnidadeModel) {
    this.unidade = { ...unidade};
  }

  apagarUnidadeDialog(unidadeId: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {name: 'Deseja apagar este unidade ?', from: 'tipo-componente.component.ts'}
    });

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      console.log(confirmed.apagar);
      if (confirmed.apagar === true) {
        this.apagarUnidade(unidadeId);
      }
    });
  }

  apagarUnidade(unidadeId: Number) {
    this.unidadeService.apagarUnidade(unidadeId).subscribe(() => {
      this.openSnackBarSuccess('Unidade excluído com sucesso !');
      this.listarUnidade();
    }, err => {
      console.error(err);
      this.openSnackBarError('Erro ao tentar excluír o unidade !');
    });
  }

  changePage(event) {
    this.listPageUnidade(event.page, event.size);
    this.pageAtual = event.page;
   }

  scroll() {
    this.targetEl.nativeElement.scrollIntoView();
  }

  onSubmit() {
    this.submit = true;
  }

  getAuthority() {
    this.getItemAuthority('authority');
    if (this.arrayString.includes('ADD_EMPRESA')) {
      this.creatorUnidade = true;
    }
    if (this.arrayString.includes('EDIT_EMPRESA')) {
      this.editorUnidade = true;
    }
    if (this.arrayString.includes('LIST_EMPRESA')) {
      this.listaUnidade = true;
    }
    if (this.arrayString.includes('DELETE_EMPRESA')) {
      this.deletaUnidade = true;
    }
    if (this.arrayString.includes('SUPER_USER')) {
      this.superUser = true;
    }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
      try {
        const bytes = CryptoJS.AES.decrypt(
          store,
          sessionStorage.getItem('ticket-ECM')
        );
        this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return this.arrayString;
      } catch (e) {
        sessionStorage.clear();
      }
    }

    return null;
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/endereco-components/unidade/unidade.component.ts